<template>
  <ul class="steps my-steps has-content-centered">
    <li class="steps-segment" v-bind:class="{'is-active': 0 === value}">
      <a
        href="#"
        class="steps-marker"
        v-bind:class="{'is-warning': errorSteps[0].length}"
        v-on:click="setStep(0)"
      >
        <div v-if="errorSteps[0].length">!</div>
      </a>
      <div class="steps-content">
        <p>Device Setup</p>
      </div>
    </li>
    <li class="steps-segment" v-bind:class="{'is-active': 1 === value}">
      <a
        href="#"
        class="steps-marker"
        v-bind:class="{'is-warning': errorSteps[1].length}"
        v-on:click="setStep(1)"
      >
        <div v-if="errorSteps[1].length">!</div>
      </a>
      <div class="steps-content">
        <p>Device Material</p>
      </div>
    </li>
    <li class="steps-segment" v-bind:class="{'is-active': 2 === value}">
      <a
        href="#"
        class="steps-marker"
        v-bind:class="{'is-warning': errorSteps[2].length}"
        v-on:click="setStep(2)"
      >
        <div v-if="errorSteps[2].length">!</div>
      </a>
      <div class="steps-content">
        <p>Simulation Setup</p>
      </div>
    </li>
    <li class="steps-segment" v-bind:class="{'is-active': 3 === value}">
      <a
        href="#"
        class="steps-marker"
        v-bind:class="{'is-warning': errorSteps[3].length}"
        v-on:click="setStep(3)"
      >
        <div v-if="errorSteps[3].length">!</div>
      </a>
      <div class="steps-content">
        <p>Probes</p>
      </div>
    </li>
    <li class="steps-segment" v-bind:class="{'is-active': 4 === value}">
      <a href="#" class="steps-marker" v-on:click="setStep(4)"></a>
      <div class="steps-content">
        <p>Run</p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    value: Number,
    errorSteps: Object,
  },
  methods: {
    setStep(newStep) {
      this.$emit('setStep', newStep);
    },
  },
};
</script>

<style scoped>
ul.my-steps {
  margin-top: 4em;
  margin-bottom: 4em;
}
</style>
